import React from 'react'
import DefaultLeadsPage from '../../components/LeadsDataWithFilter'

function Index() {
    return (
        <DefaultLeadsPage leadType="Tvs" />
    )
}

export default Index